import { DevicesMap } from "fleet/view/device/devices-map";
import { connect } from "react-redux";
import { getConnDeviceStatus } from "redux-store/connection/selectors";
import { deviceStatusesSelector } from "redux-store/device-statuses";
import * as FeatureFlags from "redux-store/feature-flags/selectors";
import { makeGetAllAsArray } from "redux-store/selectors";

const getAllDevicesAsArray = makeGetAllAsArray();

function mapStateToProps(state) {
  return {
    devices: getAllDevicesAsArray(state.global.devices),
    deviceStatuses: deviceStatusesSelector(state),
    deviceStatusOnline: getConnDeviceStatus(state),
    featureFlags: FeatureFlags.getFeatureFlags(state),
  };
}

const ConnectedAllDevicesMap = connect(mapStateToProps)(DevicesMap);

export { ConnectedAllDevicesMap };
